<template lang="pug">
    #app(:class="{ 'is-simple-mode': isSimpleMode }")
        script(
            type="application/ld+json"
            v-html="getSchema()"
        )

        #top
        Offline
        Header(id="Header")

        Explode(v-show="hasErrors")
        Success(v-show="hasSuccesses")
        main
            nuxt
        Footer(id="Footer")

        MobileNav(v-if="$device.isSmall")

        OverlayInit
        Notifications

        div(
            v-if="$storyblok.isEditing"
            class="fixed inset-0 z-[60]"
        )
</template>

<script>
import Header from '@/components/header/'
import Footer from '@/integrations/storyblok/footer/'
import Explode from '@/components/explode' // if there is a network error this lazy load would blow up too :)
import Offline from '@/components/offline'
import OverlayInit from '@/components/overlay/init'
import Notifications from '@/components/notifications'
const MobileNav = () =>
    import(/* webpackChunkName: "mobile-nav" */ '@/integrations/storyblok/mobileNav')
const Success = () => import(/* webpackChunkName: "success" */ '@/components/success')

export default {
    name: 'App',
    components: {
        Header,
        Footer,
        Explode,
        Offline,
        OverlayInit,
        Notifications,
        MobileNav,
        Success,
    },
    head() {
        // Make sure we have styles first
        if (!this.$sitewideData.styles) return {}

        // Adding sitewide styles to keep reactivity for editing and previewing in Storyblok
        return {
            style: [
                {
                    type: 'text/css',
                    cssText: this.$sitewideData.css,
                },
            ],
            link: this.$sitewideData.fontPreloads,
            __dangerouslyDisableSanitizers: ['style'], // We need to disable santizing the style tags because of the single quotes on font-faces
        }
    },
    computed: {
        isSimpleMode() {
            return this.$store.state.isSimpleMode
        },
        hasErrors() {
            return this.$store.state.generalErrors.length > 0
        },
        hasSuccesses() {
            return this.$store.state.generalSuccesses.length > 0
        },
    },
    mounted() {
        this.$store.dispatch('setGlobalId')
        this.$store.dispatch('cart/getCart')

        // This will start filling the fitment select data from algolia.
        this.$store.dispatch('fitment/initSelects')
    },
    methods: {
        getSchema() {
            return JSON.stringify({
                '@context': 'http://schema.org',
                '@type': 'WebSite',
                url: `https://${this.$config.runtime.domain}`,
                potentialAction: {
                    '@type': 'SearchAction',
                    target: `https://${this.$config.runtime.domain}/search/?q={search_term_string}`,
                    'query-input': 'required name=search_term_string',
                },
            })
        },
    },
}
</script>

<style lang="stylus">
.offline-fade-enter-active, .offline-fade-leave-active {
  transition: opacity .5s;
}
.offline-fade-enter, .offline-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
